<template>
  <div class="groupSend">
    <div class="head-title">个人群发</div>
    
    <div class="help">
      <p>
        1、当企业需要向众多客户发送节日祝福、促销活动、新产品上市等消息，管理员可在后台剪辑好文案，可包括文章、图片、小程序等内容。
      </p>
      <p>2、创建任务可分不同成员、客户标签、客户群等内容进行分类发布。</p>
      <p>
        3、员工收到群发任务后并确认发布，这样能提升企业的工作效率，利用群发机会，做好客户的营销和服务。
      </p>
      <p>
        4、每位客户/每个客户群每天可接收1条群发消息。
      </p>
    </div>
    <div class="">
      <nav class="navbar">
        <div class="narbar-l">
          <span class="shij">
            <el-button @click="addrun()" icon="el-icon-plus" type="primary"
              >新建群发</el-button
            >
          </span>
          <span class="shij">
            <el-button
              @click="toggleSelection()"
              icon="el-icon-delete"
              type="danger"
              >删除</el-button
            >
          </span>
        </div>
        <div class="narbar-r">
          <el-input
            clearable
            placeholder="搜索"
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
            <el-button slot="append" @click="rune()" type="primary"
              >查询</el-button
            >
          </el-input>
        </div>
      </nav>
      <el-table
        :data="tableData.data"
        border
        style="width: 100%; margin-top: 2.0rem"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="任务名称"></el-table-column>
        <el-table-column
          prop="scope"
          label="发送范围"
          width="240"
        ></el-table-column>
        <el-table-column
          prop="if_send"
          label="发送类型"
          width="240"
        ></el-table-column>
        <el-table-column prop="username" label="发送人员">
          <template slot-scope="scope">
            <template v-if="scope.row.username.length > 0">
              <el-tag
                size="mini"
                style="margin: 2px"
                v-for="t in scope.row.username"
                :key="t"
                >{{ t }}</el-tag
              >
            </template>
          </template>
        </el-table-column>
        <el-table-column label="发送内容" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="cont">
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createtime"
          label="创建时间"
          width="240"
        ></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <template v-if="scope.row.status === '成功'">
              <i
                class="el-icon-success"
                style="color: #6fc24d; font-size: 2.0rem; vertical-align: middle"
              ></i>
            </template>
            <template v-else>
              <i
                class="el-icon-error"
                style="color: #f43939; font-size: 2.0rem; vertical-align: middle"
              ></i>
            </template>
            {{ scope.row.status }}
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="tableData.total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="[10,20,50,100]"
        :auto-scroll="false"
        @pagination="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  components: {
    Pagination,
  },
  data() {
    return {
      title: {},
      tooken: "",
      tableData: {
        total: 0,
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: "",
      value1: true,
      form: {
        name: "",
        none: "",
        customer_deal_days: "",
        customer_follow_days: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      customer_deal_days: "",
      customer_follow_days: "",
      lock: true,
      code: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    toggleSelection() {
      this.axios
        .post(
          "/crm/Assistant/delMass",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            ids: this.multipleSelection,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    handleSelectionChange(val) {
      var arr = [];
      val.map((i) => {
        arr.push(i.id);
      });
      this.multipleSelection = arr.toString();
    },
    addrun() {
      this.$router.push({
        name: "groupSendDetail",
      });
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/Assistant/getMassList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.name,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Assistant/getMassList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    bianji(e, o, l, p) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
      this.customer_follow_days = l;
      this.customer_deal_days = p;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/editCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.bianjile,
            id: this.ele,
            customer_follow_days: this.customer_follow_days,
            customer_deal_days: this.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/addCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,

            phone: this.tooken.phone,
            name: this.form.name,
            customer_follow_days: this.form.customer_follow_days,
            customer_deal_days: this.form.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerLevel/delCustomerLevel",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.groupSend {
  height: 100%;
}
.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}
.navbar {
  display: flex;
  justify-content: space-between;
}
.shij {
  display: inline-block;
  margin-right: 24px;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem 6px .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 3.1rem;
  overflow: hidden;
}
.cont {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 3.0rem;
  font-size: 15px;
}
</style>
